import { useEffect, useState, useContext } from 'react';
import { downloadSumsubReport, fetchAvailableSumsubReport } from 'services/complianceReportsServices';
import AuthContext from "contexte/AuthContext"
import { useTranslation } from 'react-i18next';
import DashboardLayout from 'components/layout/dashboard/DashboardLayout'
import Notification from 'components/notifications/Notification';
import { launchError } from 'components/notifications';
import DownloaderLink from 'components/DownloaderLink/DownloaderLink';
import './sumsub.css'

const SumsubReports = () => {

  const { user } = useContext(AuthContext);
  const { t } = useTranslation();
  const [files, setFiles] = useState([]);

  useEffect(() => {
    const fetchReportList = async () => {
      try {
        const data = await fetchAvailableSumsubReport({ user, type: 'sumsub' });
        setFiles(data);
      } catch (error) {
        launchError(t('notifications.reports.compliance.list.error'))
      }
    }

    fetchReportList();
  }, [])

  return (
    <DashboardLayout page={t("pages_name.report_compliance_sumsub")}>
      <Notification />
      <div className='sumsub_titleComponent'>
        <h2>{t("pages.report_compliance_sumsub.title")}</h2>
      </div>
      <div>
        <ul>
          {files.map(file => (
            <DownloaderLink
              filename={`sumsub_${file}.xlsx`}
              fetchData={downloadSumsubReport}
              fetchDataParams={{ user, type: 'sumsub', fileName: file }}
              type={'excel'}
              display={file}
              key={file}
            />
          ))}
        </ul>
      </div>
    </DashboardLayout>
  )
}

export default SumsubReports;